import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import addanotherApiController from "../../services/addanother.service";
import HandleError from "../HandleError";
import HandleResponse from "../HandleResponse";
import { contentErrorMessage } from "./contentError";

const addAnotherErrorMessage = (action, fallback) => contentErrorMessage(action, fallback);

export const AddAnotherServicesApi = createAsyncThunk("addanother/addanotherservices", async (formValues, thunkAPI) => {
  try {
    const resposedata = await addanotherApiController
      .services(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "addanotherservices"))
      .catch((error) => HandleError(thunkAPI, error, "addanotherservices"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const AddAnotherServicePriceApi = createAsyncThunk("addanother/addanotherserviceprice", async (formValues, thunkAPI) => {
  try {
    const resposedata = await addanotherApiController
      .serviceprice(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "addanotherserviceprice"))
      .catch((error) => HandleError(thunkAPI, error, "addanotherserviceprice"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const AddAnotherStaffOptionsApi = createAsyncThunk("addanother/addanotherstaffOptions", async (formValues, thunkAPI) => {
  try {
    const resposedata = await addanotherApiController
      .staff(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "addanotherstaffOptions"))
      .catch((error) => HandleError(thunkAPI, error, "addanotherstaffOptions"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const AddAnotherResourceOptionsApi = createAsyncThunk("addanother/addanotherresourceOptions", async (formValues, thunkAPI) => {
  try {
    const resposedata = await addanotherApiController
      .addanotherserviceresourceitems(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "addanotherresourceOptions"))
      .catch((error) => HandleError(thunkAPI, error, "addanotherresourceOptions"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

export const StaffAvailableTimeApi = createAsyncThunk("addanother/StaffAvailableTime", async (formValues, thunkAPI) => {
  try {
    const resposedata = await addanotherApiController
      .staffavailabletime(formValues, thunkAPI)
      .then((response) => HandleResponse(thunkAPI, response, "StaffAvailableTime"))
      .catch((error) => HandleError(thunkAPI, error, "StaffAvailableTime"));
    return resposedata;
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
    return thunkAPI.rejectWithValue(message);
  }
});

const initialState = {
  availabilityRequestId: null,
  isAddAnother: [], //{ serviceprice: "", services: [], staff: [], duration: "", cost: "" }
  isAddAnotherServices: [],
  isAddAnotherServicesError: "",
  isAddAnotherServicePrice: [],
  isAddAnotherServicePriceError: "",
  isAddAnotherStaffOptions: [],
  isAddAnotherStaffOptionsError: "",
  isAddAnotherResourceOptions: [],
  isAddAnotherResourceOptionsError: "",
  isStaffAvailableTime: [],
  isStaffAvailableTimeError: "",
  isApiStatus: {
    AddAnotherServicesApi: "",
    AddAnotherServicePriceApi: "",
    AddAnotherResourceOptionsApi:""
  },
};

const addanotherSlice = createSlice({
  name: "addanother",
  initialState,
  reducers: {
    reset: () => initialState,
    AddAnotherData: (state, action) => {
      if (action.payload) {
        const { id, ...changes } = action.payload;
        const existingData = state.isAddAnother.find((event) => event.id === id);
        if (existingData) {
          Object.keys(changes).map((keyName) => {
            existingData[keyName] = changes[keyName];
          });
        } else {
          state.isAddAnother = [...state.isAddAnother, action.payload];
        }
      } else {
        state.isAddAnother = [];
      }
    },
    AddAnotherDataRemove: (state, action) => {
      const { id } = action.payload;
      state.isApiStatus = { ...state.isApiStatus, serviceDeleteApi: "succeeded" };
      const newisAddAnother = state.isAddAnother ? state.isAddAnother.filter((item) => item.id != id) : state.isAddAnother.filter((item) => item.id != id);
      state.isAddAnother = newisAddAnother.map((item, index) => ({ ...item, id: index + 1 }));
    },
  },
  extraReducers:(builder)=> {
    builder
    .addCase(AddAnotherServicesApi.pending, (state) => {
      state.isAddAnotherServicesError = "";
      state.isApiStatus = { ...state.isApiStatus, AddAnotherServicesApi: "loading" };
    })
    .addCase(AddAnotherServicesApi.fulfilled, (state, action) => {
      state.isAddAnotherServices = action.payload;
      state.isAddAnotherServicesError = "";
      state.isApiStatus = { ...state.isApiStatus, AddAnotherServicesApi: "succeeded" };
    })
    .addCase(AddAnotherServicesApi.rejected, (state, action) => {
      state.isApiStatus = { ...state.isApiStatus, AddAnotherServicesApi: "failed" };
      state.isAddAnotherServicesError = addAnotherErrorMessage(action, "Unable to load add-another services.");
    })
    .addCase(AddAnotherServicePriceApi.pending, (state) => {
      state.isAddAnotherServicePriceError = "";
      state.isApiStatus = { ...state.isApiStatus, AddAnotherServicePriceApi: "loading" };
    })
    .addCase(AddAnotherServicePriceApi.fulfilled, (state, action) => {
      state.isAddAnotherServicePrice = action.payload;
      state.isAddAnotherServicePriceError = "";
      state.isApiStatus = { ...state.isApiStatus, AddAnotherServicePriceApi: "succeeded" };
    })
    .addCase(AddAnotherServicePriceApi.rejected, (state, action) => {
      state.isApiStatus = { ...state.isApiStatus, AddAnotherServicePriceApi: "failed" };
      state.isAddAnotherServicePriceError = addAnotherErrorMessage(action, "Unable to load add-another service prices.");
    })
    .addCase(AddAnotherStaffOptionsApi.pending, (state) => {
      state.isAddAnotherStaffOptionsError = "";
      state.isApiStatus = { ...state.isApiStatus, AddAnotherStaffOptionsApi: "loading" };
    })
    .addCase(AddAnotherStaffOptionsApi.fulfilled, (state, action) => {
      state.isAddAnotherStaffOptions = action.payload;
      state.isAddAnotherStaffOptionsError = "";
      state.isApiStatus = { ...state.isApiStatus, AddAnotherStaffOptionsApi: "succeeded" };
    })
    .addCase(AddAnotherStaffOptionsApi.rejected, (state, action) => {
      state.isApiStatus = { ...state.isApiStatus, AddAnotherStaffOptionsApi: "failed" };
      state.isAddAnotherStaffOptionsError = addAnotherErrorMessage(action, "Unable to load add-another staff options.");
    })
    .addCase(AddAnotherResourceOptionsApi.pending, (state) => {
      state.isAddAnotherResourceOptionsError = "";
      state.isApiStatus = { ...state.isApiStatus, AddAnotherResourceOptionsApi: "loading" };
    })
    .addCase(AddAnotherResourceOptionsApi.fulfilled, (state, action) => {
      state.isAddAnotherResourceOptions = action.payload;
      state.isAddAnotherResourceOptionsError = "";
      state.isApiStatus = { ...state.isApiStatus, AddAnotherResourceOptionsApi: "succeeded" };
    })
    .addCase(AddAnotherResourceOptionsApi.rejected, (state, action) => {
      state.isApiStatus = { ...state.isApiStatus, AddAnotherResourceOptionsApi: "failed" };
      state.isAddAnotherResourceOptionsError = addAnotherErrorMessage(action, "Unable to load add-another resource options.");
    })
    .addCase(StaffAvailableTimeApi.pending, (state, action) => {
        state.availabilityRequestId = action.meta.requestId;
      state.isStaffAvailableTimeError = "";
      state.isApiStatus = { ...state.isApiStatus, StaffAvailableTimeApi: "loading" };
    })
    .addCase(StaffAvailableTimeApi.fulfilled, (state, action) => {
        if (action.meta?.requestId && state.availabilityRequestId !== action.meta.requestId) return;
      state.isStaffAvailableTime = action.payload;
      state.isStaffAvailableTimeError = "";
      state.isApiStatus = { ...state.isApiStatus, StaffAvailableTimeApi: "succeeded" };
    })
    .addCase(StaffAvailableTimeApi.rejected, (state, action) => {
        if (action.meta?.requestId && state.availabilityRequestId !== action.meta.requestId) return;
      state.isApiStatus = { ...state.isApiStatus, StaffAvailableTimeApi: "failed" };
      state.isStaffAvailableTimeError = addAnotherErrorMessage(action, "Unable to load add-another availability.");
    });  
  },
});
// Action creators are generated for each case reducer function
export const { reset, AddAnotherData, AddAnotherDataRemove } = addanotherSlice.actions;
export default addanotherSlice.reducer;
